import CryptoJS from 'crypto-js'

const keyArr = [
  "0290337bc6d54666b99ac1a493c9241c",
  "8206fa574cbd48cc979b546cc7534cbe",
  "4d7d0e1ddc584396be5a88c27e293661",
  "a7018dd44d594eeba4688ddabc5a20d1",
  "0c4ac077a9184f20942ee89630ec14a7",
  "7f835e74d9dc4ac89457426dc281519c",
  "01e929d5f6e240b898e66bf6b110f18a"
]
const ivArr = [
  "37fa7b0462d7f6a3",
  "37fa77f6a463b02d",
  "37fa77f6b0462a3d",
  "37fa77f60462da3b",
  "37fa73b0462d7f6a",
  "a3b037fa77f6462d",
  "a737f7f0462d6a3b"
]

const index = (new Date().getDate()) % 7
const key = CryptoJS.enc.Utf8.parse(keyArr[index])
const iv = CryptoJS.enc.Utf8.parse(ivArr[index]);


export function encryption(iphoneNumber) {
  console.log(index)
  // 加密方法
  const content = iphoneNumber + new Date().getTime()
  const encryptedContent = CryptoJS.AES.encrypt(content, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,  
    padding: CryptoJS.pad.Pkcs7
  })
  return encryptedContent.ciphertext.toString()
}

export function decode(encStr) {
  const decryptedContent = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(encStr), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,  
    padding: CryptoJS.pad.Pkcs7
  })
  const decodeStr = CryptoJS.enc.Utf8.stringify(decryptedContent)
  return  decodeStr.slice(0, decodeStr.length-13)
}

